import getApiUrl from 'src/config/api';
import { selectFingerprint } from 'src/modules/User';
import ApiError from 'src/utils/error';
import { ACTION_TYPES } from './constants';
import api from './api';

export const initializeRestaurant = (slug, fingerprint, token, lang) => async (dispatch) => {
    const result = await api.initializeRestaurant(slug, fingerprint, token, lang).then((response) => {
        dispatch({
            type: ACTION_TYPES.RESTAURANT_INITIALIZED,
            payload: { ...response, lang }
        });
    }).catch((error) => {
        dispatch({
            type: ACTION_TYPES.RESTAURANT_CANNOT_BE_INITIALIZED,
            payload: error?.firstMessage
        });

        if (error.statusCode === 404) {
            return error;
        }
    });

    return result;
};

export const initializeCode = (code, fingerprint, token, lang) => async (dispatch) => {
    const result = await api.initializeCode(code, fingerprint, token, lang).then((response) => {
        dispatch({
            type: ACTION_TYPES.RESTAURANT_INITIALIZED,
            payload: { ...response, code, lang }
        });
    }).catch((error) => {
        dispatch({
            type: ACTION_TYPES.RESTAURANT_CANNOT_BE_INITIALIZED,
            payload: error?.firstMessage
        });

        if (error.statusCode === 404) {
            return error;
        }
    });

    return result;
};

export const showInfo = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.SHOW_INFO
    });
};

export const hideInfo = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.HIDE_INFO
    });
};

export const readInfo = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.READ_INFO
    });
};

export const sendCallWaiter = (context) => async (dispatch, getState) => {
    const { sessionId } = context;
    const fingerprint = selectFingerprint(getState());

    dispatch({
        type: ACTION_TYPES.CALL_WAITER
    });

    await fetch(`${getApiUrl()}/api/client/clientSessions/${sessionId}/waiterCalls`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            fingerprint
        })
    }).then((response) => {
        if (response.status === 200) {
            dispatch({
                type: ACTION_TYPES.CALL_WAITER_SUCCESS
            });
        } else {
            return response.json().then((json) => { throw new ApiError(json); });
        }
    }).catch((error) => {
        dispatch({
            type: ACTION_TYPES.CALL_WAITER_FAILED,
            payload: error?.firstMessage
        });
    });
};

export const waiterCalled = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.WAITER_CALLED
    });
};

export const fetchLastBill = ({ restaurantId }) => async (dispatch, getState) => {
    const fingerprint = selectFingerprint(getState());

    await fetch(`${getApiUrl()}/api/client/restaurants/${restaurantId}/lastBillSummary?fingerprint=${fingerprint}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            return response.json().then((json) => { throw new ApiError(json); });
        }
    }).then((response) => {
        dispatch({
            type: ACTION_TYPES.LAST_BILL_FETCHED,
            payload: response
        });
    }).catch((error) => {
        dispatch({
            type: ACTION_TYPES.LAST_BILL_FETCHING_FAILED,
            payload: error?.firstMessage
        });
    });
};

export const publishNewMenu = (token) => async (dispatch) => {
    await fetch(`${getApiUrl()}/api/restaurant/restaurants/menuVisibility`, {
        method: 'PATCH',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            isVisible: true
        })
    }).then((response) => {
        if (!response.ok) {
            return response.json().then((json) => { throw new ApiError(json); });
        }
    }).then(() => {
        dispatch({
            type: ACTION_TYPES.NEW_MENU_PUBLISHED
        });
    }).catch((error) => {
        dispatch({
            type: ACTION_TYPES.NEW_MENU_PUBLISH_FAILED,
            payload: error?.firstMessage || 'Error.canNotPublishMenu'
        });
    });
};

export const clearPublishNewMenu = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.CLEAR_PUBLISH_MENU_ERROR
    });
};
